import {
  ApplicationContext,
  ApplicationContextParameters,
  TEnvironment,
} from '@upside/spa-shared-context';

import { ApplicationConfiguration } from './configuration/application';
import { frontEnds } from './const';

let applicationContext: ApplicationContext | null = null;

export function getApplicationContext(): ApplicationContext {
  if (!applicationContext) {
    throw new Error('Application context not initialized');
  }
  return applicationContext;
}

export default async (
  configuration: ApplicationConfiguration,
): Promise<ApplicationContext> => {
  const parameters: ApplicationContextParameters = {
    authenticationUrl: configuration.authenticationUrl as string,
    staticDataUrl: configuration.staticDataUrl as string,
    apiKey: configuration.apiKey as string,
    organisationUrl: configuration.organisationUrl as string,
    frontEnds,
    environment: configuration.environment as TEnvironment,
    allowedRedirectDomains: configuration.allowedRedirectDomains as string[],
  };

  applicationContext = await ApplicationContext.create(parameters);
  return applicationContext;
};
